import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdresseModels} from 'src/app/models/adresse-models';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';

@Component({
    selector: 'app-kontakt-eintrag',
    templateUrl: './kontakt-eintrag.component.html',
    styleUrls: ['./kontakt-eintrag.component.scss'],
})
export class KontaktEintragComponent implements OnInit {
    @Input() formGroupPartner: UntypedFormGroup;
    public errormsg: string = '';
    public hasError: boolean = false;
    public anreden: AdresseModels.AddressSalutation[] = [];
    public briefAnreden: AdresseModels.AddressLetterSalutation[] = [];
    public briefAnredenAbgefuellt: AdresseModels.AddressLetterSalutation[] = [];
    public zuHanden: string[] = [];
    public zuHandenAbgefuellt: string[] = [];
    private currAnsprechPartner?: AdresseModels.AnsprechPartnerElement;
    private vorname: string = '';
    private name: string = '';

    constructor(
        private svcAdressen: AdresseDataService,
        private swissSettings: SwissSettingsService,
        private svcMessageBox: MessageBoxService,
        public dialogRef: MatDialogRef<KontaktEintragComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AdresseModels.AnsprechPartnerElement
    ) {
        if (data) {
            this.currAnsprechPartner = this.data!;
        } else {
            throw Error('cant be empty supply, ansprechpartnerelement');
        }

        this.formGroupPartner = new UntypedFormGroup({
            fldPartnerPersKontakt: new UntypedFormControl(),
            fldPartnerAlsHauptkontakt: new UntypedFormControl(),
            fldPartnerName: new UntypedFormControl(),
            fldPartnerVorname: new UntypedFormControl(),
            fldPartnerAnrede: new UntypedFormControl(),
            fldPartnerBriefanrede: new UntypedFormControl(),
            fldPartnerZuHanden: new UntypedFormControl(),
            fldPartnerInfo: new UntypedFormControl(),
            fldPartnerMobile: new UntypedFormControl(),
            fldPartnerTelefon: new UntypedFormControl(),
            fldPartnerEmail: new UntypedFormControl(),
            fldPartnerHomepage: new UntypedFormControl(),
        });

        this.zuHanden.push('Herr');
        this.zuHanden.push('Frau');

        this.formGroupPartner.patchValue({
            fldPartnerPersKontakt: !!this.data.pers,
            fldPartnerAlsHauptkontakt: !!this.data.hauptAnsprechpartner,
            fldPartnerName: this.data.lastName ? this.data.lastName : this.data['name'],
            fldPartnerVorname: this.data.firstName ? this.data.firstName : this.data['vorname'],
            fldPartnerAnrede: this.data.anrede,
            fldPartnerBriefanrede: this.data.briefanrede,
            fldPartnerZuHanden: this.data.zuhanden,
            fldPartnerInfo: this.data.ansprechInfo,
            fldPartnerMobile: this.data.mobile ? this.data.mobile : this.data['natel'],
            fldPartnerTelefon: this.data.telefon,
            fldPartnerEmail: this.data.email,
            fldPartnerHomepage: this.data.homepage,
        });
    }

    ngOnInit(): void {
        this.svcAdressen.getAnreden(true).subscribe({
            next: (res: AdresseModels.AddressSalutation[]) => {
                this.anreden = res;
            },
            error: (error: any) =>
                console.error('Fehler beim Ermitteln der Kontakt-Anreden.', error),
        });

        this.svcAdressen.getBriefanreden(true).subscribe({
            next: (res: AdresseModels.AddressLetterSalutation[]) => {
                this.briefAnreden = res;
                this.genBriefanreden();
            },
            error: (error: any) =>
                console.error('Fehler beim Ermitteln der Kontakt-Briefanreden.', error),
        });
    }

    onVornameChange(event: Event) {
        this.vorname = (event.target as HTMLInputElement).value;
        this.genBriefanreden();
    }

    onNameChange(event: Event) {
        this.name = (event.target as HTMLInputElement).value;
        this.genBriefanreden();
    }

    async genBriefanreden() {
        // Hier werden die originalen Briefanreden mit Platzhaltern in das anzuzeigende Array kopiert
        this.briefAnredenAbgefuellt = [];
        this.briefAnreden.forEach((val) =>
            this.briefAnredenAbgefuellt?.push(Object.assign({}, val))
        );

        // Hier werden die Platzhalter im Array ersetzt (Nachname)
        if (this.briefAnredenAbgefuellt) {
            this.briefAnredenAbgefuellt.forEach((briefAnredObj, index) => {
                if (briefAnredObj) {
                    if (briefAnredObj.briefanrede.includes('%2')) {
                        // Name
                        if (this.name) {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace(
                                '%2',
                                this.name
                            );
                        } else {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace(
                                '%2',
                                ''
                            );
                        }
                        this.briefAnredenAbgefuellt[index] = briefAnredObj;
                    }

                    if (briefAnredObj.briefanrede.includes('%1')) {
                        // Vorname
                        if (this.vorname) {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace(
                                '%1',
                                this.vorname
                            );
                        } else {
                            briefAnredObj.briefanrede = briefAnredObj.briefanrede.replace(
                                '%1',
                                ''
                            );
                        }
                        this.briefAnredenAbgefuellt[index] = briefAnredObj;
                    }
                }
            });
        }

        // zuHanden - Auswahl erstellen
        this.zuHandenAbgefuellt = [];
        this.zuHanden.forEach((a) => {
            if (this.vorname && this.name) {
                this.zuHandenAbgefuellt.push(a + ' ' + this.vorname + ' ' + this.name);
            } else if (this.name) {
                this.zuHandenAbgefuellt.push(a + ' ' + this.name);
            } else {
                this.zuHandenAbgefuellt.push(a);
            }
        });
    }

    onAnredeChange(anrede: AdresseModels.AddressSalutation) {
        this.formGroupPartner.controls['fldPartnerAnrede'].setValue(anrede.anrede);
    }

    onBriefanredeChange(briefAnrede: AdresseModels.AddressLetterSalutation) {
        this.formGroupPartner.controls['fldPartnerBriefanrede'].setValue(
            briefAnrede.briefanrede
        );
    }

    onZuHandenChange(zuHanden: string) {
        this.formGroupPartner.controls['fldPartnerZuHanden'].setValue(zuHanden);
    }

    save() {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Ansprechpartner-FormValues: ', this.formGroupPartner.value);
        }

        try {
            if (this.formGroupPartner.value) {
                // persönlicher Kontakt
                if (
                    this.formGroupPartner.controls['fldPartnerPersKontakt'].value === true
                ) {
                    this.currAnsprechPartner!.pers = 1;
                } else {
                    this.currAnsprechPartner!.pers = 0;
                }
                // als Haptansprechpartner definieren
                if (
                    this.formGroupPartner.controls['fldPartnerAlsHauptkontakt'].value ===
                    true
                ) {
                    this.currAnsprechPartner!.hauptAnsprechpartner = 1;
                } else {
                    this.currAnsprechPartner!.hauptAnsprechpartner = 0;
                }
                // Nachname
                this.currAnsprechPartner!.lastName =
                    this.formGroupPartner.controls['fldPartnerName'].value;
                // Vorname
                this.currAnsprechPartner!.firstName =
                    this.formGroupPartner.controls['fldPartnerVorname'].value;
                // Anrede
                this.currAnsprechPartner!.anrede =
                    this.formGroupPartner.controls['fldPartnerAnrede'].value;
                // Briefanrede
                this.currAnsprechPartner!.briefanrede =
                    this.formGroupPartner.controls['fldPartnerBriefanrede'].value;
                // zu Handen
                this.currAnsprechPartner!.zuhanden =
                    this.formGroupPartner.controls['fldPartnerZuHanden'].value;
                // Info
                this.currAnsprechPartner!.ansprechInfo =
                    this.formGroupPartner.controls['fldPartnerInfo'].value;
                // Mobile
                this.currAnsprechPartner!.mobile =
                    this.formGroupPartner.controls['fldPartnerMobile'].value;
                // Telefon
                this.currAnsprechPartner!.telefon =
                    this.formGroupPartner.controls['fldPartnerTelefon'].value;
                // Email
                this.currAnsprechPartner!.email =
                    this.formGroupPartner.controls['fldPartnerEmail'].value;
                // Homepage
                this.currAnsprechPartner!.homepage =
                    this.formGroupPartner.controls['fldPartnerHomepage'].value;
            }

            this.dialogRef.close(this.currAnsprechPartner);

        } catch (ex) {
            this.hasError = true;
            this.errormsg = 'Fehler bei der Speicherung des Ansprechpartners: ';
            console.error(this.errormsg, ex);
            this.svcMessageBox.showError(
                'Die Eingaben konnten nicht der Entität (AnsprechPartnerElement) zugewiesen werden!! Fehler: ' +
                ex,
                '!! FEHLER !!'
            );
        }
    }
}
